export function extractPlainText(rec: any): string {
  if (!rec) return '';
  
  // If it's already a string, return it
  if (typeof rec === 'string') return rec;

  // Helper to safely extract text from a record-like object
  const getFromRecord = (obj: any): string | null => {
    if (!obj || typeof obj !== 'object') return null;
    
    // 1. Direct text property (most common for raw records)
    if (typeof obj.text === 'string') return obj.text;
    
    // 2. Rich text object: { text: { text: "...", facets: [...] } }
    if (obj.text && typeof obj.text === 'object' && typeof obj.text.text === 'string') {
      return obj.text.text;
    }
    
    // 3. Nested value (common in ViewRecord)
    if (obj.value && typeof obj.value === 'object') {
      // Special case: if obj.value.text exists, return it
      if (typeof obj.value.text === 'string') return obj.value.text;
      // Otherwise recurse
      const val = getFromRecord(obj.value);
      if (typeof val === 'string') return val;
    }
    
    // 4. Nested record (common in PostView)
    if (obj.record && typeof obj.record === 'object') {
      // Special case: if obj.record.text exists, return it
      if (typeof obj.record.text === 'string') return obj.record.text;
      // Otherwise recurse
      const val = getFromRecord(obj.record);
      if (typeof val === 'string') return val;
    }

    return null;
  };

  const result = getFromRecord(rec);
  if (typeof result === 'string') return result;

  // 5. Last resort: deep search for any string property named 'text'
  try {
    const stack = [rec];
    const seen = new Set();
    while (stack.length > 0) {
      const current = stack.pop();
      if (!current || typeof current !== 'object' || seen.has(current)) continue;
      seen.add(current);

      // If this object has a 'text' property that is a string, we found it
      if (typeof current.text === 'string') return current.text;

      // If text is an object with a text property (rich text)
      if (current.text && typeof current.text === 'object' && typeof current.text.text === 'string') {
        return current.text.text;
      }

      // Don't go too deep into known large objects that aren't records
      if (current.author || current.viewer || current.embed) {
        // But do check their record/value if they have one
        if (current.record) stack.push(current.record);
        if (current.value) stack.push(current.value);
        continue;
      }

      for (const key in current) {
        const val = current[key];
        if (val && typeof val === 'object') {
          stack.push(val);
        }
      }
    }
  } catch (e) {
    // ignore
  }

  // If we still have nothing, return empty string to avoid [object Object]
  return '';
}
